module.exports = __webpack_public_path__ + "media/images/welcome_page_roles_and_permissions-787937ea09f196e76f13209c77c82d88.png";